/**
 * @file Help component for fieldsets
 * @author Heino Lenting
 */
/**
 * Class for the help functionality
 */
var HelpComponent = /** @class */ (function () {
    function HelpComponent() {
        this.open = false;
        this.orientation = 'left';
    }
    /**
     * An outside click event
     */
    HelpComponent.prototype.clickOutside = function (e) {
        if (this.isOpen()) {
            this.setClose();
        }
    };
    /**
     * Test if the help is open
     * @returns Returns if help is open
     */
    HelpComponent.prototype.isOpen = function () {
        return (this.open === true);
    };
    /**
     * Test if the help is closed
     * @returns Returns if help is closed
     */
    HelpComponent.prototype.isClosed = function () {
        return (this.open === false);
    };
    /**
     * Set help component open and use auto remove after a few seconds
     */
    HelpComponent.prototype.setOpen = function () {
        // Open tooltip
        this.open = true;
        // Auto remove after 5 seconds
        this.startDelayedClose();
    };
    /**
     * Close the help component and cancel the auto remove
     */
    HelpComponent.prototype.setClose = function () {
        // Close tooltip
        this.open = false;
        // Clear existing interval
        this.cancelDelayedClose();
    };
    /**
     * Toggle between open or closed
     * @param event The click event
     */
    HelpComponent.prototype.toggle = function (event) {
        // Calculate orientation
        this.calculateOrientation(event);
        // Toggle between open en close
        if (this.isOpen()) {
            this.setClose();
        }
        else {
            this.setOpen();
        }
    };
    /**
     * Test if the orientation of the help component is right
     * @returns Return if orientation is right
     */
    HelpComponent.prototype.isRightOrientated = function () {
        return (this.orientation === 'right');
    };
    /**
     * Test if the orientation of the help component is left
     * @returns Return if orientation is left
     */
    HelpComponent.prototype.isLeftOrientated = function () {
        return (this.orientation === 'left');
    };
    /**
     * Close the dropdown if current interface element is not active
     */
    HelpComponent.prototype.closeIfNotLastOpenComponent = function (component) {
        if (this.open && this !== component) {
            this.setClose();
        }
    };
    /**
     * Start a delayed close
     */
    HelpComponent.prototype.startDelayedClose = function () {
        var _this = this;
        // Close help text after 5 seconds
        this.timeoutId = window.setTimeout(function () {
            _this.open = false;
            _this.cancelDelayedClose();
        }, 5000);
    };
    /**
     * Cancel a delayed close
     */
    HelpComponent.prototype.cancelDelayedClose = function () {
        // Clear timeout if exists
        if (this.timeoutId !== null) {
            window.clearTimeout(this.timeoutId);
            this.timeoutId = null;
        }
    };
    /**
     * Calculate the orientation of the help component based on the position of the element in browser
     * @param event The HTML event argument that triggered this method.
     */
    HelpComponent.prototype.calculateOrientation = function (event) {
        // If an event is given, calculate the orientation
        if (event) {
            if (event.pageX < window.innerWidth / 2) {
                // right orientation
                this.orientation = 'right';
            }
            else {
                // left orientation
                this.orientation = 'left';
            }
        }
    };
    return HelpComponent;
}());
export { HelpComponent };
